import React, { Component } from "react";

import NavBar from "../nav/NavBar/NavBar";
import CommonSidebar from "../../app/common/util/Sidebar";
import NotificationList from "./NotificationList";

class NotificationListPage extends Component {
  render() {
    return (
      <div className="notification-list-page">
        <CommonSidebar />
        <NavBar />
        <NotificationList />
      </div>
    );
  }
}

export default NotificationListPage;
